'use strict';

import React from 'react';

export default function IconMapMarker (props) {
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.70931 15.3149C1.91557 11.813 0 8.71862 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 8.71862 10.0844 11.813 6.29069 15.3149C6.12652 15.4665 5.87348 15.4665 5.70931 15.3149ZM2.57143 6C2.57143 7.89355 4.10645 9.42857 6 9.42857C7.89355 9.42857 9.42857 7.89355 9.42857 6C9.42857 4.10645 7.89355 2.57143 6 2.57143C4.10645 2.57143 2.57143 4.10645 2.57143 6ZM8.57143 6C8.57143 7.42016 7.42016 8.57143 6 8.57143C4.57984 8.57143 3.42857 7.42016 3.42857 6C3.42857 4.57984 4.57984 3.42857 6 3.42857C7.42016 3.42857 8.57143 4.57984 8.57143 6ZM6 0.857143C8.84032 0.857143 11.1429 3.15968 11.1429 6C11.1429 8.35872 9.44005 11.1731 6 14.414C2.55995 11.1731 0.857143 8.35872 0.857143 6C0.857143 3.15968 3.15968 0.857143 6 0.857143Z" fill="#0168BB"/>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Icons/IconMapMarker.jsx